export default "__VITE_ASSET__DmLstaxE__"